<template>
  <div
    class="card mt-3"
    :style="{ 'min-height': $store.state.screenHeight - 100 + 'px' }"
  >
    <div class="card-body text-center">
      <h1 style="font-weight: bold;">รายงานกำไรขั้นต้น</h1>
      <div class="row">
        <div class="col-sm-2">

        </div>
        <div class="col-sm-4">
          <div class="form-group row">
            <label
              for="date"
              class="col-sm-3 col-form-label text-right"
            >จากวันที่</label>
            <div class="col-sm-9">
              <a-date-picker
                v-model="startDate"
                :format="'DD/MM/YYYY'"
                class="form-control"
                id="date"
              />
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group row">
            <label
              for="date"
              class="col-sm-3 col-form-label text-right"
            >ถึงวันที่</label>
            <div class="col-sm-9">
              <a-date-picker
                v-model="endDate"
                :format="'DD/MM/YYYY'"
                class="form-control"
                id="date"
              />
            </div>
          </div>
        </div>
        <div class="col-sm-2">

        </div>
      </div>
      <div class="row">
        <div class="col-sm-2"></div>
        <div class="col-sm-3">
          <button
            type="button"
            class="btn btn-success btn-block"
            @click="getReport"
          >
            <i class="fas fa-redo"></i> ประมลผล
          </button>
        </div>
        <div class="col-sm-3">
          <form
            action="/static/pdf/report_cost_sale.php"
            method="POST"
            target="_blank"
          >
            <input
              type="hidden"
              name="date_start"
              v-model="startDate"
            >
            <input
              type="hidden"
              name="date_end"
              v-model="endDate"
            >
            <input
              type="hidden"
              name="data"
              v-model="form_data"
            >
            <button
              type="submit"
              :disabled="sum_qty() === 0"
              class="btn btn-primary btn-block"
            >
              <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
            </button>
          </form>
        </div>
        <div class="col-sm-3">
          <form
            action="/static/excel/report_cost_sale.php"
            method="POST"
            target="_blank"
          >
            <input
              type="hidden"
              name="date_start"
              v-model="startDate"
            >
            <input
              type="hidden"
              name="date_end"
              v-model="endDate"
            >
            <input
              type="hidden"
              name="data"
              v-model="form_data"
            >
            <button
              type="submit"
              :disabled="sum_qty() === 0"
              class="btn btn-info btn-block"
            >
              <i class="far fa-file-excel"></i> บันทึกเป็น Excel
            </button>
          </form>
        </div>
        <div class="col-sm-2"></div>
      </div>
      <div class="table-responsive-sm mt-3">
        <table class="table">
          <thead>
            <tr class="text-left">
              <td colspan="6">
                วันที่: <span>{{ dateFormatDMY(startDate) }}</span>
                <span v-if="dateFormatDMY(startDate) !== dateFormatDMY(endDate)">ถึง วันที่: {{ dateFormatDMY(endDate) }}</span>
              </td>
            </tr>
          </thead>
          <tbody
            v-for="(d, i) in report_data"
            :key="'d' + i"
          >
            <tr
              class="text-left"
              style="background: #f7f7f7;"
              v-if="d.profit.sub.length > 0"
            >
              <th colspan="6">
                สาขา: {{ d.profit.sub[0].branch_name }}
              </th>
            </tr>
            <tr
              class="text-left"
              style="background: #f7f7f7;"
              v-if="d.profit.sub.length > 0"
            >
              <th colspan="6">
                หมวดหมู่: {{ d.group_name }}
              </th>
            </tr>
            <tr
              class="text-left"
              style="background: #f7f7f7;"
              v-if="d.profit.sub.length > 0"
            >
              <th colspan="6">
                {{ d.profit.date }}
              </th>
            </tr>
            <tr
              class="thead-dark"
              v-if="d.profit.sub.length > 0"
            >
              <th width="20%">รหัส: ชื่อ</th>
              <th width="15%">จำนวน</th>
              <th width="10%">มูลค่าขาย</th>
              <th width="10%">มูลค่าทุนชื้อ</th>
              <th width="10%">กำไรขั้นต้น</th>
              <th width="10%">กำไร %</th>
            </tr>
            <tr
              v-for="(sub, i) in d.profit.sub"
              v-show="d.profit.sub.length > 0"
              :key="'sub' + i"
            >
              <td class="text-left">{{ sub.item_code || '-'}}: {{ sub.item_name || '-' }}</td>
              <td class="text-right">{{ numberFormatDecimal(sub.qty) }}</td>
              <td class="text-right">{{ numberFormatDecimal(sub.avg_cost_sale) }}</td>
              <td class="text-right">{{ numberFormatDecimal(sub.avg_cost_buy) }}</td>
              <td class="text-right">{{ numberFormatDecimal(sub.gross_profit) }}</td>
              <td class="text-right">{{ numberFormat(sub.gpm) }} %</td>
            </tr>
            <tr
              v-if="d.profit.sub.length > 0"
              style="background: #f7f7f7;"
            >
              <th class="text-left">รวม</th>
              <th class="text-right">{{ numberFormatDecimal(d.profit.sum_qty) }}</th>
              <th class="text-right">{{ numberFormatDecimal(d.profit.sum_avg_cost_sale) }}</th>
              <th class="text-right">{{ numberFormatDecimal(d.profit.sum_avg_cost_buy) }}</th>
              <th class="text-right">{{ numberFormatDecimal(d.profit.sum_gross_profit) }}</th>
              <th class="text-right">{{ numberFormatDecimal(d.profit.sum_gpm) }}</th>
            </tr>
          </tbody>
          <tr v-if="sum_qty() === 0">
            <th
              scope="row"
              colspan="6"
            >ไม่มีข้อมูล</th>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import api from '../services/service_report'

export default {
  data () {
    return {
      report_data: [],
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: ''
    }
  },
  methods: {
    getReport () {
      var obj = {
        start_date: this.dateFormatDMY2(this.startDate),
        end_date: this.dateFormatDMY2(this.endDate),
        company_id: this.$store.state.user.company_id,
        branch_id: [this.$store.state.user.branch_id],
        item_code: ''
      }

      this.$store.commit('Loading')
      api.profitReport(
        this.REST_URL,
        this.header,
        obj,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.report_data = result.data
            this.form_data = JSON.stringify(result.data)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    sum_qty () {
      var sumQty = 0
      this.report_data.forEach(val => {
        val['profit']['sub'].forEach(v => {
          sumQty += v['cn_qty']
        })
      })
      return sumQty
    }
  },
  mounted () {
    this.checkUser()
    this.getReport()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report_cost_sale.vue